import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowDown } from "@fortawesome/free-solid-svg-icons";
import React, { useContext } from 'react';
import { Context } from "../contexts/AppContext";

const LinkMediaVideoHeader = ({ appState }) => {
  const { value } = useContext(Context);  
  const [appState1, setAppState] = value; 

  const downloadBtnClk = () => {
    setAppState((prevState) => {
      return { 
        ...prevState,
        modalData: { ...prevState.modalData, type: "DownloadVideoModal", isOpen: true }
      };
    }); 
  };

  const watchOnTvBtnClk = () => {
    setAppState((prevState) => {
      return { 
        ...prevState,
        modalData: { ...prevState.modalData, type: "WatchOnTvModal", isOpen: true }
      };
    }); 
  };

  const shareBtnClk = () => {
    const currentUrl = window.location.href;
    navigator.clipboard.writeText(currentUrl)
      .then(() => {
        alert('URL copied to clipboard!');
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };

  return (
    <>
      <header className="p-4 overflow-hidden">
        <div className="flex justify-between items-center sm:h-16 w-[90vw] sm:w-[98vw]">
          {/* Brand Section */}
          <div>
            <div className="flex items-center flex-col sm:flex-row">
              <div className="w-16 h-16 mx-auto p-5 bg-white rounded-full relative flex items-center justify-center overflow-hidden">
                <img
                  alt="brand"
                  loading="lazy"
                  decoding="async"
                  src={
                    appState?.adminDetails?.companyLogoUrl
                      ? `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${appState?.adminDetails?.companyLogoUrl}?width=480&height=480&optimize=image`
                      : '/img/logo.webp?width=480&height=480&optimize=image'
                  }
                  style={{
                    position: 'absolute',
                    height: '100%',
                    width: '100%',
                    inset: 0,
                    objectFit: 'contain',
                    color: 'transparent',
                    padding: '3px'
                  }}
                />
              </div>
              <div className="flex flex-col items-center sm:items-start sm:ml-5">
                <div className="w-full text-base text-white font-medium my-2 brand-name-shadow">
                  {appState?.adminDetails?.companyName}
                </div>
              </div>
            </div>
          </div>

          {/* Buttons Section */}
          <div className="flex items-center gap-1 px-4">

            
            {/* TV Button */}
            {appState?.currentGalleryData?.setting?.tv && (
              <button
                id="gallery-tv-connect"
                onClick={watchOnTvBtnClk}
                className="flex gap-1 items-center justify-center text-white rounded-full bg-[#0000001c]
                           w-10 h-10 md:w-12 md:h-12 hover:bg-[#6a6a6a] transition-all duration-200"
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="tv"
                  className="w-3 h-3"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 512"
                >
                  <path
                    fill="currentColor"
                    d="M64 64l0 288 512 0 0-288L64 64zM0 64C0 28.7 28.7 0 64 0L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 416c-35.3 0-64-28.7-64-64L0 64zM128 448l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-384 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                  />
                   
                </svg>
                <span className="text-xs  ">TV</span>
              </button>
            )}

            {/* Download Button */}
            {appState?.currentGalleryData?.setting?.download && (
              <button
                onClick={downloadBtnClk}
                className="flex items-center justify-center text-white rounded-full bg-[#0000001c]
                           w-10 h-10 md:w-12 md:h-12 hover:bg-[#6a6a6a] transition-all duration-200"
              >
                <FontAwesomeIcon icon={faCloudArrowDown} className="w-4 h-4" />
              </button>
            )}

            {/* Share Button */}
            {appState?.currentGalleryData?.setting?.share && (
              <button
                onClick={shareBtnClk}
                className="flex items-center justify-center text-white rounded-full bg-[#0000001c]
                           w-10 h-10 md:w-12 md:h-12 hover:bg-[#6a6a6a] transition-all duration-200"
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="share-nodes"
                  className="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                >
                  <path
                    fill="currentColor"
                    d="M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"
                  />
                </svg>
              </button>
            )}
          </div>
        </div>
      </header>
    </>
  );
};

export default LinkMediaVideoHeader;
